import ProposalResponse from './ProposalResponse';
export default ProposalResponse;